import React from "react";

const ReturnsPolicy = () => {
  const policySections = [
    {
      title: "Returns Eligibility",
      content: [
        "The product must be unused, undamaged, and in the original packaging.",
        "The return request must be made within 7 days of receiving the product.",
        "The product must not be part of any non-returnable category such as personalized items, perishable goods, or hygiene-related products.",
      ],
      isList: true,
      icon: "bi-check-circle",
      iconColor: "text-success",
    },
    {
      title: "Return Shipping Costs",
      content: [
        "<strong>For faulty or damaged items:</strong> Lazmy will bear the return shipping cost.",
        "<strong>For change of mind or other reasons:</strong> The customer is responsible for return shipping costs.",
      ],
      isList: false,
      icon: null,
      iconColor: null,
    },
    {
      title: "Refunds",
      content: [
        "Once we receive the returned item, we will inspect it for eligibility. If the item meets our return criteria, we will process the refund to your original payment method within 7-10 business days. Please note that shipping charges are non-refundable. If you used a discount or promo code on the original order, the refund will be adjusted accordingly.",
      ],
      isList: false,
      icon: null,
      iconColor: null,
    },
    {
      title: "Exchanges",
      content: [
        "Currently, we do not offer direct exchanges. If you wish to exchange a product, please return the original item and place a new order for the replacement.",
      ],
      isList: false,
      icon: null,
      iconColor: null,
    },
    {
      title: "Non-Returnable Items",
      content: [
        "Personalized products",
        "Underwear and intimate apparel",
        "Health and hygiene products",
        "Gift cards",
      ],
      isList: true,
      icon: "bi-x-circle",
      iconColor: "text-danger",
    },
    {
      title: "Defective or Damaged Products",
      content: [
        "If you receive a defective or damaged item, please contact us within 48 hours of delivery. We will arrange for a free return and issue a full refund or replacement, depending on your preference.",
      ],
      isList: false,
      icon: null,
      iconColor: null,
    },
  ];

  return (
    <section className="container container-lg py-5 px-40">
      <h2 className="text-center mb-4 text-3xl fw-bold">Lazmy Return Policy</h2>
      <div className="flex-center w-100">
        <p className="text-center text-muted mb-5 col-lg-7 col-md-8 col-sm-12">
          At Lazmy, we strive to ensure that you are completely satisfied with
          your purchase. If you are not fully satisfied, we offer a hassle-free
          return process to make your shopping experience as convenient as
          possible.
        </p>
      </div>

      {policySections.map((section, index) => (
        <div key={index} className="my-20">
          <h3 className="text-xl mb-4 font-weight-bold">{section.title}</h3>
          {section.isList ? (
            <ul className="list-unstyled">
              {section.content.map((item, idx) => (
                <li
                  key={idx}
                  className="d-flex align-items-lg-center align-items-sm-start justify-content gap-4 mb-3"
                >
                  <i
                    className={`bi ${section.icon} ${section.iconColor} me-3`}
                    style={{ fontSize: "1.5rem" }}
                    aria-label={section.title}
                  ></i>
                  <div
                    className="text-muted mb-5"
                    dangerouslySetInnerHTML={{ __html: item }}
                  ></div>
                </li>
              ))}
            </ul>
          ) : (
            section.content.map((item, idx) => (
              <p
                key={idx}
                className="text-muted mb-5"
                dangerouslySetInnerHTML={{ __html: item }}
              ></p>
            ))
          )}
        </div>
      ))}
    </section>
  );
};

export default ReturnsPolicy;
